module.exports = {
  siteTitle: 'Young Lives',
  siteTitleAlt: 'Young Lives', // This allows an alternative site title for SEO schema.
  publisher: 'Young Lives', // Organization name used for SEO schema
  siteDescription:
    'Young Lives Is A Specialist Consultancy That Works In Partnership With Schools And Parents To Provide Flexible And Bespoke Support To Young People On A Wide Range Of Health Matters.',
  siteUrl: 'https://young-lives.com', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  author: 'Lesley Messenger-Jones', // Author for RSS author segment and SEO schema
  authorUrl: 'https://young-lives.com/what', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@younglivesuk', // Change for Twitter Cards
  shortTitle: 'Young Lives', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 900, // Change to the width of your default share image
  shareImageHeight: 600, // Change to the height of your default share image
  siteLogo: '/logos/yl.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#ffffff', // Used for Offline Manifest
  themeColor: '#ffffff', // Used for Offline Manifest
  copyright: 'Copyright © 2018 Young Lives', // Copyright string for the RSS feed
}



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js